import { ObjectMode } from '@databases/types';
import { Database } from '@databases/types/database';
import { getNewDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants';

export const getEmptyDatabase = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getNewDatabase();

  return {
    ...baseDatabase,
    contentId: databasesToContentId['emptyDatabase'],
    meta: {
      ...baseDatabase.meta,
      isLocked: false,
    },
    space: { key: 'TEST', name: 'Test', id: 1234 },
    operations: {
      delete: false,
      updateEntries: true,
      updateMetadata: true,
    },
  } as Database<ObjectMode.EXISTING>;
};
